<template>
    <div class="page" :style="{ '--styleColor': bgcolor, 'backgroundImage': 'url('+bgimg+')','backgroundRepeat': 'no-repeat', 'backgroundSize':'100%'}">
      <TipsHbrb ref="child"></TipsHbrb>
      <div class="mainBox">
        <div class="video-container">
          <div id="video" class="video" style="width: 100%;height:100%;"></div>
        </div>
        <div class="title" v-show="infoData.title">{{infoData.title}}</div>
        <div class="author" v-show="infoData.origin">{{infoData.origin}}</div>
        <div class="content" v-html="infoData.content"></div>
        <div class="navBox">
          <div class="navTxt" @click="toIndex">
            <div class="icoBox"><img src="@/assets/images/learn/index_off.png" alt=""></div>
            <div class="icoTitle">首页</div>
          </div>
          <div class="navTxt" @click="toHome">
            <div class="icoBox"><img src="@/assets/images/learn/list_on.png" alt=""></div>
            <div class="icoTitle">课程列表</div>
          </div>
          <div class="navTxt" @click="toHistory">
            <div class="icoBox"><img src="@/assets/images/learn/history_off.png" alt=""></div>
            <div class="icoTitle">学习进度</div>
          </div>
      </div>
      </div>
     
    </div>
  </template>
  
  <script> 
  import TipsHbrb from '@/components/TipsHbrb.vue'

  import {reqLine,reqScore} from '@/api/index' //动态接口
  import {reqLessionsInfo, reqWatchTime, reqAddScore} from '@/api/learn' //静态接口

  import bgimg from '@/assets/images/learn/pbg.jpg';
  //分享
  import { wxShare } from '@/utils/wxshare-wes2.com.js'
  import zonglan from '@/utils/cp-zonglan.js'

  export default {
    name: 'show',
    components: {
      TipsHbrb,
    },
    data () {
      return {
        bgimg:bgimg,
        bgcolor:'#e4f3fa',
        learnid:0,
        token:"",
        accountId:'',
        uniqueId:'',
        userid:0,
        lessionid:0,
        infoData:[],
        timeScheduleAdjust:5,
        shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
        shareTitle:"",
        shareDesc:"", 
        style:{},
      }
    },
    computed: {},
    created (){
      this.learnid = this.$route.query.learnid;
      if(this.$route.query.hasOwnProperty("lessionid")){
        this.lessionid = this.$route.query.lessionid;
      }else{
        this.$toast({
          icon: 'warning-o',
          message: "您访问的信息错误或不存在"
        });
      }
      this.token = this.$store.state.token;
      this.accountId = this.$store.state.accountId;
      this.uniqueId = this.$store.state.uniqueId;
      this.userid = this.$store.state.userid;         
      this.shareImg = this.$store.state.actInfo.share_img;
      this.shareTitle = this.$store.state.actInfo.share_title;
      this.shareDesc = this.$store.state.actInfo.share_desc;
      this.actInfo = this.$store.state.actInfo;

      if(this.actInfo.forward==0) {
        this.timeScheduleAdjust = 5;
      } else {
        this.timeScheduleAdjust = 2;
      }

    },
    mounted () {      
      this.getLession()  
      zonglan.pageShare(0,'',this.shareImg,this.shareTitle,this.shareDesc);
    },    
    methods: {
        toIndex(){
          window.location.href="https://hbxw.hebnews.cn/qnyx/index.html#/?app_control=1101";
        },
        toHome(){
          this.$router.push({ path: '/list',query:this.$route.query })
        },
        toHistory(){
          this.$router.push({ path: '/history',query:this.$route.query })
        },
        toMyCenter(){
          this.$router.push({ path: '/mycenter',query:this.$route.query })
        } ,
        getLession() {
          reqLessionsInfo({learnid:this.learnid, lessionid:this.lessionid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
            if(res.code==200) {
              this.infoData = res.data;
              this.loadCkplayer()
            } else {
              this.$toast({
                  duration:5000,
                  icon: 'warning-o',
                  message: res.msg
              });
            }
          }).catch(err => {
            console.log('err',err);
          })        
        },

        setLine() {
          reqWatchTime({learnid:this.learnid,lessionid:this.lessionid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId}).then(res => {
            if(res.code==200) {
              localStorage.setItem('isClick_'+this.lessionid+'_'+this.accountId,1);
            } else {
              this.$toast({
                  duration:5000,
                  icon: 'warning-o',
                  message: res.msg
              });
            }
          }).catch(err => {
            console.log('err',err);
          })        
        },
        setScore() {
          reqAddScore({learnid:this.learnid,lessionid:this.lessionid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId}).then(res => {
            if(res.code==200) {
              //更新本地已观看数据
              let viewed = localStorage.getItem(this.learnid+'_viewed');
              let status = viewed.split(',').includes(this.lessionid);
              if(!status){
                if(viewed==''){
                  localStorage.setItem(this.learnid+'_viewed',this.lessionid);
                } else {
                  localStorage.setItem(this.learnid+'_viewed',viewed+','+this.lessionid);
                }              
              }

              if(this.infoData.zscore > 0 ){
                this.$toast({
                    duration:5000,
                    icon: 'warning-o',
                    message: res.msg
                });
              }
            } else {
              this.$toast({
                  duration:5000,
                  icon: 'warning-o',
                  message: res.msg
              });
            }
          }).catch(err => {
            console.log('err',err);
          })        
        },
        loadCkplayer(){
            let seekTime = localStorage.getItem('lession_'+this.lessionid);
            seekTime = parseFloat(seekTime);
            console.log('seekTime',seekTime);
            let videoObject = {
                    container: '#video',//视频容器的ID
                    // video: 'https://video.hebnews.cn/asset/ff03be35e4fde9432fb91d2f10c9c50a/play_video/df633c7ec1410db752346a78ce6b2982_0.mp4',//视频地址
                    video: [
                            [this.infoData.video_st, 'video/mp4', '标清'],
                            [this.infoData.video_hd, 'video/mp4', '高清']
                        ],
                    volume: 0.8,//默认音量，范围0-1
                    poster: this.infoData.poster,//封面图片地址
                    autoplay: false,//是否自动播放
                    loop: false,//是否需要循环播放
                    rotate:0,//视频旋转角度
                    zoom:0,//默认缩放比例
                    live: false,//是否是直播
                    ad:null,//广告
                    backLive:false,//显示返回直播按钮
                    seek: seekTime,//默认需要跳转的秒数
                    next: null,//下一集按钮动作
                    loaded: '',//加载播放器后调用的函数
                    plug:'',//使用插件，目前支持hls.js:用于在pc端播放m3u8，flv.js:播放flv，mpegts.js：播放ts
                    duration:0,//如果强制使用点播，而视频里不存在总时间，可以手动指定
                    preview: null,//预览图片对象
                    prompt: null,//提示点功能
                    crossOrigin:'',//发送跨域信息，示例：Anonymous            
                    type:'',//视频类型
                    playbackrate: 1,//默认倍速
                    ended:null,//结束显示的内容
                    webFull:false,//是否启用页面全屏按钮，默认不启用
                    theatre:null,//是否启用剧场模式按钮，默认不启用
                    controls:false,//是否显示自带控制栏
                    rightBar:null,//是否开启右边控制栏
                    smallWindows:null,//是否启用小窗口模式
                    smallWindowsDrag:true,//小窗口开启时是否可以拖动
                    screenshot:false,//截图功能是否开启
                    timeScheduleAdjust:this.timeScheduleAdjust,//是否可调节播放进度,0不启用，1是启用，2是只能前进（向右拖动），3是只能后退，4是只能前进但能回到第一次拖动时的位置，5是看过的地方可以随意拖动
                    logo:'',//logo
                    menu:null,//右键菜单
                    information:{//关于
                    'Load:':'{loadTime} second',
                    'Duration:':'{duration} second',
                    'Size:':'{videoWidth}x{videoHeight}',
                    'Volume:':'{volume}%',
                    'Sudio decoded:':'{audioDecodedByteCount} Byte',
                    'Video decoded:':'{videoDecodedByteCount} Byte'
                    },
                    track:null,//字幕
                    title:'',//视频标题
                    language:'',//语言包文件
                    barHideTime:500,//控制栏隐藏时间
                    playbackrateOpen:true,//是否开启控制栏倍速选项
                    playbackrateList:[1,1.25,1.5,2],//倍速配置值
                    cookie:'lession_'+this.lessionid,//cookie名称，在同一域中请保持唯一
                    looked:'lession_watched_',
                    domain:null,//cookie保存域
                    cookiePath:'/',//cookie保存路径
                    documentFocusPause:false,//窗口失去焦点后暂停播放
                    mouseWheelVolume:2,//是否启用鼠标滚轮调节音量功能，0=不启用，1=启用，2=全屏时才启用
                    keyVolume:2//是否启用键盘控制音量调节，0=不启用，1=启用，2=全屏时才启用
                };
            this.player = new ckplayer(videoObject); //初始化播放器

            // //定位至播放时间且seek的状态为seeked后，再禁止拖动进度条
            let _this = this;            

            //监听到播放
            this.player.play(function () {
                console.log('监听到播放');

                var time = localStorage.getItem(videoObject.cookie);
                _this.player.vars('timeScheduleAdjust',1);                
                _this.player.seek(time);
                _this.player.seek(function(obj){
                  console.log(obj);
                  if(obj['state']==="seeked") {//设定记忆播放时间结束
                    _this.player.vars('timeScheduleAdjust',_this.timeScheduleAdjust);//禁止拖动
                  }		
                });

                if(!localStorage.getItem('isClick_'+_this.lessionid+'_'+_this.token)){
                  _this.setLine() //设置时间线
                }
            });

            this.player.pause(function(){
              _this.player.vars('timeScheduleAdjust',_this.timeScheduleAdjust);//禁止拖动
            })

            //监听到播放结束
            this.player.ended(function(){
              console.log('监听到播放结束');
              if(parseInt(localStorage.getItem(videoObject.cookie))==parseInt(_this.player.duration())){
                //请求后端，验证是否符合观看规则并增加积分
                _this.setScore()
              }


            });
        }
    }
    
  }
  </script>
  
  <style lang="scss" scoped>
  @import '@/assets/css/show.scss';
  </style>